/*
 * @Author: your name
 * @Date: 2020-11-17 16:08:14
 * @LastEditTime: 2021-10-29 12:02:40
 * @LastEditors: zhangmh31513
 * @Description: In User Settings Edit
 * @FilePath: \openplat-web\src\gtn\store\getters.js
 */
const getters = {
  loginInfo: state => state.user.loginInfo,
  user: state => state.user.user,
  uPlusUser: state => state.user.uPlusUser,
  asstReloginFlag: state => state.user.asstReloginFlag,
  token: state => state.user.token,
  hsid: state => state.user.user.hsid,
  newsActiveTab: state => state.product.newsActiveTab,
  urlList: state => state.product.urlList,
  optAuths: state => state.user.optAuths,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  searchRoute: state => state.permission.searchRoute,
  lock: state => state.app.lock,
  sidebar: state => state.app.sidebar,
  activeIndex: state => state.app.activeIndex,
  menusRoot: state => state.app.menusRoot, //有多个子系统
  menusNoRoot: state => state.app.menusNoRoot,
  visitedViews: state => state.app.visitedViews,
  roles: state => state.user.roles,
  fullScreen: state => state.app.fullScreen,
  marking: state => state.market.marking,
  tabKey: state => state.market.tabKey,
  isCloud: state => state.market.isCloud,
  timeOver: state => state.app.timeOver,
  isEnrollTips: state => state.app.isEnrollTips,
  photonNum: state => state.app.photonNum,
  lightShow: state => state.app.lightShow,
  competeUser: state => state.financialCompetition.user,
  captainInfo: state => state.financialCompetition.captainInfo,
  teamInfo: state => state.financialCompetition.teamInfo,
  companyList: state => state.financialCompetition.companyList
};
export default getters;



// WEBPACK FOOTER //
// ./src/gtn/store/getters.js